import { PoolConfig, usePool } from '@trustpad/launchpad';

import * as React from 'react';

import { TMain } from '~common/UI';
import { usePriceCoinGecko } from '~common/hooks/usePriceCoinGecko';
import { CoingeckoLink, CoinMarketCapLink } from '~features/launched';
import { fNum } from '~utils';

import { ListItem } from './InfoListItem';
import { Title } from './UI';

const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);
const getRoundLabel = (access: PoolConfig['access']) => {
  if (['whitelist', 'levels_fcfs', 'public'].includes(access)) return 'IDO';
  return `${capitalizeFirstLetter(access)} round`;
};
const getPercentIncrease = (init, value) =>
  ((100 * (value - init)) / init).toFixed(2);

export function PriceSection() {
  const {
    pool,
    pool: { token, sale },
  } = usePool();
  const prices = usePriceCoinGecko(token.coingeckoId);

  if (!sale.rate && !token.listingRate) {
    return null;
  }

  return (
    <div>
      <div className="flex">
        <Title>Price</Title>

        <div className="ml-3 flex gap-3">
          {token.coingeckoId && <CoingeckoLink id={token.coingeckoId} />}
          {token.coinmarketcapId && (
            <CoinMarketCapLink id={token.coinmarketcapId} />
          )}
        </div>
      </div>

      <ul>
        {token.listingRate > 0 ? (
          <>
            <ListItem label="Listing">
              {
                <TMain>
                  ${fNum(1 / token.listingRate)} (+
                  {getPercentIncrease(token.listingRate, sale.rate)}%)
                </TMain>
              }
            </ListItem>
            {/*<ListItem label="IDO">*/}
            {/*  {<TMain>${fNum(1 / token.listingRate)}</TMain>}*/}
            {/*</ListItem>*/}
            <ListItem label={getRoundLabel(pool.access)}>
              {<TMain>${fNum((1 / sale.rate), 10)}</TMain>}
            </ListItem>
          </>
        ) : (
          <ListItem label={getRoundLabel(pool.access)}>
            {<TMain>${fNum((1 / sale.rate), 10)}</TMain>}
          </ListItem>
        )}

        {prices && sale.rate && (
          <PriceList
            label="ATH"
            price={prices.athPrice}
            initPrice={1 / sale.rate}
          />
        )}
      </ul>
    </div>
  );
}

function PriceList({
  label,
  initPrice,
  price,
}: {
  label: string;
  initPrice: number;
  price: number;
}) {
  let isProfit = price / initPrice >= 1;

  return (
    <ListItem label={label}>
      <div className={` ${isProfit ? ' text-green-500' : ' text-red-500'} `}>
        ${fNum(price)} ({`${isProfit ? '+' : ''}`}
        {getPercentIncrease(initPrice, price)}%)
      </div>
    </ListItem>
  );
}
